const authentication = {
  slug: 'authentication',
  sendCodeToEmail: () => `${authentication.slug}/email`,
  confirmEmail: () => `${authentication.slug}/email/confirm`,
  signInGoogle: () => `${authentication.slug}/google`,
  signInFacebook: () => `${authentication.slug}/facebook`,
  signInTwitter: () => `${authentication.slug}/twitter`
}

export default authentication
